import { useLayoutEffect } from 'react';
import { setAssessmentTranslationProtection } from '../utils/ui/assessmentTranslation';

export function useAssessmentTranslationProtection(pathname: string): void {
  // All routes, including public pages. Reassert before paint on navigation.
  useLayoutEffect(() => {
    setAssessmentTranslationProtection(true);
  }, [pathname]);
  useLayoutEffect(() => () => setAssessmentTranslationProtection(false), []);
}
